<template>
  <div class="order-detail-chat-list" data-automation="OrderDetailChatList">
    <div class="chat-list-srcoll x-scrollbar-show" ref="refSrcollBox">
      <div class="chat-list-cont" ref="refListCont">
        <!-- 信息 -->
        <div class="chat-box" v-for="(item, idx) in msgList" :key="item.id">
          <!-- 已读未读分界线 -->
          <template v-if="item.isHistoryLine">
            <p class="history-line">————— {{ $t('HT.orderDetail.history') }} ——————</p>
          </template>
          <template v-else>
            <!-- 头像 -->
            <ux-avatar size="large" class="chat-head" :src="avatarSrc(item)"></ux-avatar>
            <!-- 内容 -->
            <div class="chat-info">
              <div class="chat-info-header">
                <p class="chat-name">
                  {{ item.user_name }}
                  <span v-if="idx === 0">{{ $t('HT.orderDetail.created') }}</span>
                </p>
                <span class="chat-time">{{ item.create_time }}</span>
              </div>
              <div :class="['chat-message', { 'is-service': String(item.send_role) === '1' }]">
                <div
                  v-if="item.messages.length"
                  :class="['chat-message-txt', { 'has-img': item.imgList.length }]"
                >
                  <p
                    class="chat-message-txt-p"
                    v-for="(msg, idx) in item.messages"
                    :key="msg + idx"
                  >
                    {{ msg }}
                  </p>
                </div>

                <!-- 图片列表 -->
                <template v-if="!reloadList.includes(item.id) || showImg">
                  <div class="chat-img-list" v-if="item.imgList.length">
                    <ux-image
                      v-for="img in item.imgList"
                      class="chat-img"
                      fit="cover"
                      :key="img"
                      :src="img"
                      :preview-src-list="item.imgList"
                    >
                      <div slot="placeholder" class="chat-img-placeholder"></div>
                    </ux-image>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>

        <!-- 工单关闭 -->
        <div class="chat-over" v-if="isOver">
          <p>————— {{ $t('HT.orderDetail.over') }} ——————</p>
          <p>{{ $t('HT.approval.message') }}：</p>
          <p>{{ $t('HT.orderDetail.over1') }}</p>
          <p>{{ $t('HT.orderDetail.over2') }}</p>
        </div>

        <template v-else>
          <!-- 工单即将结束 -->
          <p class="chat-draw-close" v-if="isShowOverTips">
            {{ $t('HT.orderDetail.msg.left') }}
            <ux-button type="primary" plain size="small" @click="onClickOver">
              {{ $t('HT.orderDetail.msg.center') }}
            </ux-button>
            {{ $t('HT.orderDetail.msg.right') }}
          </p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderDetailChatList',
  components: {},
  props: {
    list: {
      type: Array,
      default: []
    },
    isUser: {
      type: Boolean,
      default: true
    },
    // 订单状态
    orderStatus: {
      type: Number | String,
      default: ''
    }
  },
  data() {
    return {
      userData: {}, // 用户信息
      reloadList: [],
      showImg: true
    };
  },
  created() {
    this.userData = this.$store.state.login.userData;
  },
  mounted() {
    const h = this.$refs.refListCont.clientHeight;
    this.$refs.refSrcollBox.scrollTop = h;
  },
  computed: {
    msgList() {
      const res = [];
      let prevStatus = '';
      for (const item of this.list) {
        // （0：未读；1：已读）
        if (String(item.status) === '0' && prevStatus === '1' && !this.isOver) {
          // 这一条是未读 上一条是已读 则先插入一个历史消息的数据
          res.push({
            isHistoryLine: true
          });
        }
        const imgList = item.img ? item.img.split(',') : [];
        const messages = (item.message || '').split('\n').filter((item) => item);

        res.push({
          ...item,
          imgList,
          messages
        });
        prevStatus = String(item.status); // 保存上一条的已读未读状态
      }
      if (prevStatus === '1' && !this.isOver) {
        res.push({
          isHistoryLine: true
        });
      }
      return res;
    },
    isShowOverTips() {
      return String(this.orderStatus) === '2' && this.isUser && this.$hasModule(80);
    },
    // 已经关闭
    isOver() {
      return String(this.orderStatus) === '3';
    }
  },
  methods: {
    avatarSrc(data) {
      // 发送角色(1：客服  0：用户）
      return data.send_role
        ? require('@/assets/images/web/chat-my.png')
        : require('@/assets/images/web/img-chat-user.png');
    },
    // 完结工单
    onClickOver() {
      this.$emit('over-order');
    },
    reloadImg() {
      this.showImg = false;
      this.$nextTick(() => {
        this.showImg = true;
      });
    },
    showImgList(id) {
      console.log(id);
      return !this.reloadList.includes(id) || this.showImg;
    }
  },
  watch: {
    list: {
      handler(newVal, oldVal) {
        const reloadList = oldVal
          .filter((item) => String(item.img_status) === '0')
          .map((item) => item.id);
        this.reloadList = reloadList;
        this.reloadImg();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.order-detail-chat-list {
  box-sizing: border-box;
  width: 100%;
  padding: 16px 24px 24px 24px;
  overflow: hidden;

  .chat-list-srcoll {
    height: 100%;
  }

  .chat-message-txt-p {
    white-space: pre-line;
    word-break: break-word;
  }

  .chat-box {
    margin-bottom: 40px;
    display: flex;

    &:last-of-type {
      margin-bottom: 8px;
    }

    .history-line {
      position: relative;
      height: 16px;
      font-size: 12px;
      font-weight: 400;
      color: $color-text-secondary;
      line-height: 16px;
    }

    .chat-head {
      margin-right: 8px;
      flex: 0 0 auto;
    }

    .chat-info {
      width: 720px;
    }

    .chat-info-header {
      width: 100%;
      display: flex;
      align-items: flex-end;
      height: 20px;
      margin-bottom: 8px;
    }

    .chat-name {
      color: $color-title;
      height: 20px;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      margin-right: 8px;

      span {
        font-weight: 400;
      }
    }

    .chat-time {
      height: 16px;
      font-size: 12px;
      font-weight: 400;
      color: $color-text-secondary;
      line-height: 16px;
    }

    .chat-message {
      box-sizing: border-box;
      display: inline-block;
      max-width: 100%;
      border-radius: 0px 8px 8px 8px;
      padding: 12px 16px 16px;
      color: $color-title;
      background: $color-bg-disable;

      &.is-service {
        color: #fff;
        background: $color-primary;
      }
    }

    .has-img {
      margin-bottom: 12px;
    }

    .chat-img-list {
      position: relative;
      font-size: 0;
      overflow: hidden;
    }

    .chat-img {
      position: relative;
      background: #fff;
      margin-right: 16px;
      height: 80px;
      width: 80px;

      &:last-of-type {
        margin-right: 0;
      }
    }

    .chat-img-placeholder {
      width: 100%;
      height: 100%;
      background: url('~@/assets/images/web/img-placeholder.png') no-repeat center center / content;
    }
  }

  .chat-draw-close {
    display: flex;
    align-items: center;
    color: $color-text-secondary;
    font-size: 12px;
    padding-top: 16px;

    .ux-button {
      margin: 0 4px;
    }
  }

  .chat-over {
    color: $color-text-secondary;
    font-size: 12px;
    line-height: 20px;
  }
}
</style>
